import { priceBookIdFormat, productIdFormat } from "@redotech/redo-ids/ids";
import {
  CurrencySchema,
  PriceBookEntrySchema,
} from "@redotech/redo-model/price-book/price-book";
import { unaryRpc } from "@redotech/rpc/definition";
import * as z from "zod";

/**
 * Bulk-adds products to a price book. Each entry carries its own price,
 * currency, and kind so per-product pricing can be supported later, even though
 * callers currently send the same values for every product.
 */
export const createPriceBookEntries = unaryRpc({
  name: "createPriceBookEntries" as const,
  input: z.object({
    priceBookId: priceBookIdFormat.schema,
    entries: z
      .array(
        z.object({
          productId: productIdFormat.schema,
          fixedPrice: z.bigint().nullable().optional(),
          currency: CurrencySchema.nullable().optional(),
          kind: z.string().optional(),
        }),
      )
      .min(1),
  }),
  output: z.object({ entries: z.array(PriceBookEntrySchema) }),
});
